<script>
import Article from '../Utils/Article'

export default {
  name: "Colophon",
  components: { Article },
  props: ["colophon"],
  computed: {
    title() { return this.colophon.Title },
    sections() { return this.colophon.Body }
  }
}
</script>

<template>
  <div 
    id="colophon"
    aria-label="The colophon quadrant"
    tabindex="0"
  >
    <Article 
      :sections="sections"
    />
  </div>
</template>

<style scoped>
#colophon {
  height: 100%;
  overflow: scroll;
}

#colophon article {
  margin: 0 auto;
}
</style>
